import React from 'react'

import { FolderArchivedNotificationFragment } from '@sketch/gql-types'

import { ArchiveIcon, WorkspaceTile } from './FolderArchivedPreview.styles'
import {
  Card,
  IconTile,
  Separator,
  Tile,
  TileTitle,
  TileWrapper,
} from './TileCard.styles'

interface FolderArchivedPreviewProps {
  notification: FolderArchivedNotificationFragment
}

export const FolderArchivedPreview = ({
  notification,
}: FolderArchivedPreviewProps) => {
  const { folder, workspace } = notification

  if (!folder) return null

  return (
    <Card>
      <TileWrapper>
        <Tile>
          <IconTile aria-hidden>
            <ArchiveIcon />
          </IconTile>
          <TileTitle>{folder.name}</TileTitle>
        </Tile>

        <Separator />

        <Tile>
          <WorkspaceTile
            size="88px"
            workspaceName={workspace?.name}
            src={workspace?.avatar?.small}
          />
          {workspace?.name && <TileTitle>{workspace.name}</TileTitle>}
        </Tile>
      </TileWrapper>
    </Card>
  )
}
